"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { field, input, textLabel, focusIndicator, icon } from './styles.js';
import { useTheme } from '../utils/theming/useTheme.js';
import { ThemeProvider } from 'styled-components';

var _excluded = ["checked", "value", "onChange", "name", "label", "required", "disabled", "readOnly", "color", "inactiveColor", "inputProps", "inputRef", "onFocus", "onBlur", "variant", "id"];
/**
 * Radio buttons are used when there is a list of two or more options that are
 * mutually exclusive and the user must select exactly one choice.
 */
var Radio = function Radio(_ref) {
  var checked = _ref.checked,
    value = _ref.value,
    onChange = _ref.onChange,
    name = _ref.name,
    label = _ref.label,
    required = _ref.required,
    disabled = _ref.disabled,
    readOnly = _ref.readOnly,
    color = _ref.color,
    inactiveColor = _ref.inactiveColor,
    inputProps = _ref.inputProps,
    inputRef = _ref.inputRef,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    variantProp = _ref.variant,
    id = _ref.id,
    props = _objectWithoutProperties(_ref, _excluded);
  var handleChange = React.useCallback(function (event) {
    if (readOnly || disabled || !onChange) return;
    onChange(event);
  }, [readOnly, disabled, onChange]);
  var theme = useTheme();
  var variant = variantProp || theme.variant;
  var radioThemeWeb = theme.radio.web;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(field, _extends({
    "data-testid": "elemental-Radio-".concat(id || name, "-").concat(value),
    color: color ? color : radioThemeWeb.color
  }, props), /*#__PURE__*/React.createElement(input, _extends({
    "data-testid": "elemental-Radio-".concat(id || name, "-").concat(value, "-input"),
    type: "radio",
    checked: checked,
    value: value,
    onChange: handleChange,
    name: name,
    required: required,
    disabled: disabled || readOnly,
    $disabledStyle: disabled,
    readOnly: readOnly,
    $color: color ? color : radioThemeWeb.color,
    $inactiveColor: inactiveColor ? inactiveColor : radioThemeWeb.unselected.color,
    id: id || "elemental-Radio-".concat(name, "-").concat(value, "-input"),
    ref: inputRef,
    onFocus: onFocus,
    onBlur: onBlur
  }, inputProps)), /*#__PURE__*/React.createElement(textLabel, {
    $color: color ? color : radioThemeWeb.color,
    $variant: variant,
    $inactiveColor: inactiveColor ? inactiveColor : radioThemeWeb.unselected.color,
    htmlFor: id || "elemental-Radio-".concat(name, "-").concat(value, "-input")
  }, label), /*#__PURE__*/React.createElement(focusIndicator, {
    color: color ? color : radioThemeWeb.color
  }), /*#__PURE__*/React.createElement(icon, {
    "data-testid": "elemental-Radio-".concat(id || name, "-").concat(value, "-icon"),
    readOnly: readOnly,
    $color: color ? color : radioThemeWeb.color,
    $inactiveColor: inactiveColor ? inactiveColor : radioThemeWeb.unselected.color
  })));
};

export { Radio };
